<nz-table
  #table
  class="data-table"
  nzShowPagination
  nzTableLayout="fixed"
  [nzFrontPagination]="tableConfig.showFrontPagination"
  [nzSize]="tableConfig.size"
  [nzOuterBordered]="tableConfig.outerBordered"
  [nzShowSizeChanger]="tableConfig.showSizeChanger"
  [nzPageSizeOptions]="tableConfig.pageSizeOptions ?? DEFAULT_CHANGE_SIZE_OPTIONS"
  [nzBordered]="tableConfig.bordered"
  [nzData]="_dataList"
  [nzTotal]="tableConfig!.total"
  [(nzPageIndex)]="tableConfig.pageIndex"
  (nzPageIndexChange)="onPageIndexChange($event)"
  [nzScroll]="tableConfig.needScroll?{ x: '1100px' }:{}"
  [(nzPageSize)]="tableConfig.pageSize"
  (nzPageSizeChange)="onPageSizeChange($event)"
  [nzLoading]="tableConfig.loading"
  [nzShowQuickJumper]="showQuickJumper"
  [nzShowTotal]="rangeTotalTemplate ?? rangeTemplate"
  (nzQueryParams)="onSort($event)"
>
  <thead>
  <tr>
    <th [nzLeft]="true" [nzIndeterminate]="indeterminate" *ngIf="tableConfig.showCheckbox"
        (nzCheckedChange)="onAllChecked($event)" [nzWidth]="'40px'" [nzChecked]="allChecked"></th>
    <th *ngIf="tableConfig.showId" [nzWidth]="'50px'" [nzLeft]="tableConfig.needScroll" [nzAlign]="'center'">STT</th>
    <th *ngIf="tableConfig.expand" [nzWidth]="'50px'" [nzLeft]="tableConfig.needScroll" [nzAlign]="'center'"></th>
    <ng-container *ngFor="let head of tableConfig.headers;let headIndex=index;let last=last;let first=first;">
      <th
        [nzColumnKey]="head.field"
        [nzShowSort]="head.sort??false"
        [nzSortOrder]="null"
        [nzSortDirections]="head.sort?.sortDirections"
        [nzSortFn]="tableConfig.showFrontPagination?head.sort?.sortFn : true"

        [nzEllipsis]='head.needEllipsis'
        [nzBreakWord]='head.needBreakword'
        [nzWidth]="head.width + 'px'"
        [ngClass]="head.thClassList?head.thClassList:''"
        [nzRight]="(!!head.fixed&&head.fixedDir==='right')"
        [nzLeft]="(!!head.fixed&&head.fixedDir==='left')"
        *ngIf="(head.show===undefined||head.show===true)">
        <ng-container *ngIf="head.thTemplate;else headerTpl">
          <ng-container *ngTemplateOutlet="getTemplateRef(head.thTemplate)"></ng-container>
        </ng-container>
        <ng-template #headerTpl>
          {{head.title }}
        </ng-template>
      </th>
    </ng-container>
  </tr>

  </thead>
  <tbody>
  <tr *ngIf="tableConfig.showFilter">
    <td *ngIf="tableConfig.showCheckbox" [nzLeft]="true"></td>
    <td *ngIf="tableConfig.showId" [nzLeft]="tableConfig.needScroll"></td>
    <td *ngIf="tableConfig.expand" [nzLeft]="tableConfig.needScroll"></td>
    <ng-container *ngFor="let head of tableConfig.headers">
    <td *ngIf="(head.show===undefined||head.show===true)"
        [nzLeft]="(!!head.fixed&&head.fixedDir==='left')"
        [nzRight]="(!!head.fixed&&head.fixedDir==='right')">
      <ng-container *ngIf="head.filterTemplate">
        <ng-container *ngTemplateOutlet="getTemplateRef(head.filterTemplate)"></ng-container>
      </ng-container>
    </td>
    </ng-container>
  </tr>
  <ng-container *ngFor="let row of table.data;let rowIndex=index;trackBy:trackByTableBody">
    <tr
      (click)='doClickItem(row);$event.stopPropagation();'
      (dblclick)="rowSelected = null;$event.stopPropagation();"
      [ngClass]="{'row-checked': rowSelected && rowSelected[attrCheck] === row[attrCheck]}">
      <td class="animate-bg-0" nzEllipsis *ngIf="tableConfig.showCheckbox" [nzLeft]="true"
          (nzCheckedChange)="checkRowSingle($event,rowIndex)"
          [nzChecked]="row['_checked']"></td>
      <td *ngIf="tableConfig.showId" [nzLeft]="tableConfig.needScroll" nzEllipsis [align]="'center'">
        {{ rowIndex | ngGenericPipe: getRowIndex}}
      </td>

      <!--      Expand -->
      <td *ngIf="tableConfig.expand" [nzExpand]="expandSet.has(row[attrCheck])"
          (nzExpandChange)="onExpandChange(row, $event)"></td>
      <!--      Expand -->

      <ng-container *ngFor="let head of tableConfig.headers">
        <td *ngIf="(head.show===undefined||head.show===true)"
            [ngClass]="head.tdClassList?head.tdClassList:''"
            [nzEllipsis]="head.needEllipsis"
            [nzBreakWord]='head.needBreakword'
            [nzLeft]="(!!head.fixed&&head.fixedDir==='left')"
            [nzRight]="(!!head.fixed&&head.fixedDir==='right')">
          <ng-container *ngIf="head.tdTemplate;else rowTpl">
            <ng-container *ngTemplateOutlet="getTemplateRef(head.tdTemplate);context: getData(row)"></ng-container>
          </ng-container>
          <ng-template #rowTpl>
            <ng-container *ngIf="head.pipe;else noPipe">
              <span
                [title]="(row|tableFiledPipe:head.field|map:head.pipe)">{{row|tableFiledPipe:head.field|map:head.pipe}}</span>
            </ng-container>
            <ng-template #noPipe>
              <ng-container><span [title]="row|tableFiledPipe:head.field">{{row|tableFiledPipe:head.field }}</span>
              </ng-container>
            </ng-template>
          </ng-template>
        </td>
      </ng-container>

    </tr>
    <tr [nzExpand]="expandSet.has(row[attrCheck])" *ngIf="tableConfig.expand && expandSet.has(row[attrCheck])">
      <ng-container *ngTemplateOutlet="getTemplateRef(tableConfig.expandTmpl);context: getData(row)"></ng-container>
    </tr>
  </ng-container>
  </tbody>
</nz-table>

<ng-template #rangeTemplate let-range="range" let-total>
  <div class="group__total--table" style="display: flex; align-items: center">
    {{ range[0] }} - {{ range[1] }} của {{ total }} bản ghi
  </div>
</ng-template>

<ng-content>
</ng-content>
